import { Link } from 'react-router-dom';

export default function SoyForMatureWomenPage() {
  return (
    <div className="min-h-screen bg-white text-[#5D4037]">
      {/* Header */}
      <header className="bg-white border-b border-[#E0D7D0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">プロテイン選びの教科書</span>
        </div>
      </header>

      {/* Breadcrumb */}
      <nav className="bg-[#FAF9F8] border-b border-[#E0D7D0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a
                href="https://soyproteinranking.com/"
                className="flex items-center gap-2 text-[#8D6E63] hover:text-[#bc6355] transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#BCAAA4]">/</li>
            <li className="text-[#5D4037] whitespace-nowrap">
              大人の女性のための大豆タンパク質の力
            </li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <section className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#d4847a] px-6 py-4 rounded-lg leading-tight">
            大人の女性こそソイ！健康維持に役立つ大豆タンパク質の力とは
          </h1>

          <p className="text-[#5D4037] leading-relaxed mb-4">
            「最近、なんとなく体のリズムが変わってきた」「肌や髪のハリが気になる」…そんな変化を感じていませんか？
          </p>

          <p className="text-[#5D4037] leading-relaxed">
            年齢を重ねるごとに、女性の体はホルモンバランスの影響を大きく受けるようになります。そんなライフステージの変化に寄り添ってくれるのが、
            <span className="text-[#bc6355] font-semibold underline decoration-[#F9EBEA] decoration-4">
              「大豆タンパク質（ソイプロテイン）」
            </span>
            です。単なる栄養補給を超えた、大人の女性が知っておくべき特別なメリットを解説します。
          </p>
        </section>

        {/* Feature Section (3 Power of Soy) */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            大豆タンパク質が持つ「3つの健康力」
          </h2>

          <p className="text-[#5D4037] leading-relaxed mb-6">
            大豆は「畑の肉」と呼ばれるほど良質なタンパク源ですが、特に女性にとって嬉しい特有の成分が含まれています。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">イソフラボン</h4>
              <p className="text-sm">
                女性ホルモン（エストロゲン）と似た働きをし、ゆらぎがちな世代の体調を整えます。
              </p>
            </div>
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">骨の健康維持</h4>
              <p className="text-sm">
                タンパク質は骨の土台を作る材料。大豆イソフラボンはカルシウムの維持もサポートします。
              </p>
            </div>
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">若々しい美しさ</h4>
              <p className="text-sm">
                大豆サポニンの抗酸化作用により、内側からのエイジングケアが期待できます。
              </p>
            </div>
          </div>
        </section>

        {/* Comparison Table (Youth vs Maturity) */}
        <section className="mb-12">
          <h3 className="text-xl font-bold text-[#5D4037] mb-6">
            年齢とともに変化する「タンパク質」の重要性
          </h3>

          <div className="overflow-hidden rounded-lg border border-[#E0D7D0] shadow-sm mb-8 bg-white">
            <table className="w-full text-center">
              <thead>
                <tr className="bg-[#FAF9F8]">
                  <th className="px-6 py-4 text-sm font-semibold text-[#5D4037] border-b border-[#E0D7D0]">
                    お悩み
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-[#bc6355] border-b border-[#E0D7D0]">
                    大豆タンパク質の役割
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-[#5D4037] border-b border-[#E0D7D0]">
                    もたらす変化
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#E0D7D0]">
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">筋力の低下</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">良質なアミノ酸補給</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">代謝の下落を抑える</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">肌・髪の衰え</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">細胞の主原料となる</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">ハリとツヤをサポート</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">ホルモン変化</td>
                  <td className="px-6 py-4 text-[#bc6355] font-semibold text-sm">
                    イソフラボン含有
                  </td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">精神的な安定・体調管理</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Advice Section for Mature Women */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            無理なく続けるためのポイント
          </h2>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#5D4037] mb-4 border-l-4 border-[#bc6355] pl-3">
              「食事制限」ではなく「栄養の密度」を上げる
            </h4>
            <p className="text-[#5D4037] leading-relaxed">
              大人のダイエットは、単に食事を抜くと筋肉量や骨密度まで減ってしまい、老けた印象を与えかねません。食事の一部をソイプロテインに置き換えたり、足りないタンパク質をプラスしたりすることで、<strong>必要な栄養を守りながら美しく体を引き締める</strong>ことができます。
            </p>
          </div>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#5D4037] mb-4 border-l-4 border-[#BCAAA4] pl-3">
              植物性ならではの「軽さ」が内臓に優しい
            </h4>
            <p className="text-[#5D4037] leading-relaxed">
              脂っこいものや動物性食品が重く感じ始めた世代にとって、植物性のソイプロテインは消化の負担が少なく、胃もたれしにくいというメリットもあります。毎日飲むものだからこそ、<strong>「体に馴染む感覚」</strong>を大切に選んでみましょう。
            </p>
          </div>
        </section>

        {/* Check List Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            こんな変化を感じたら「ソイ」の始め時
          </h2>

          <div className="bg-gradient-to-br from-[#FAF9F8] to-[#F3EFEF] rounded-xl p-8 border border-[#E0D7D0] shadow-sm">
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  <i className="ri-check-line"></i>
                </div>
                <p className="text-[#5D4037]">
                  今までのダイエット方法では結果が出にくくなった
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  <i className="ri-check-line"></i>
                </div>
                <p className="text-[#5D4037]">
                  朝起きたときや夕方に、ドッと疲れを感じやすくなった
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  <i className="ri-check-line"></i>
                </div>
                <p className="text-[#5D4037]">
                  美容液を変えても、肌のハリや髪のボリュームに満足できない
                </p>
              </li>
            </ul>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>

          <div className="bg-[#bc6355] text-white rounded-xl p-8 shadow-sm">
            <div className="space-y-4 leading-relaxed">
              <p>
                大人の女性にとって、ソイプロテインは単なる「筋肉を作るための粉」ではなく、<strong>健やかなリズムを整える「お守り」</strong>のような存在です。
              </p>
              <p>
                10年後、20年後の自分も好きでいるために。今日から一杯のソイプロテインで、内側からのセルフケアを始めてみませんか？
              </p>
              <p className="pt-4 text-center font-bold border-t border-[#d4847a]">
                大豆の力を味方につけて、しなやかに、凛とした毎日を。
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}